import { ApplicationAccessType, CommunicationType } from 'domains/content/types';
import { ContentStatus } from 'pages/ContentPage/ContentTable/ContentStatusText';

import { MessageInteraction, VoiceCallRoot, VoiceContentAction, VoiceContentStateTypes } from './types';
import { actionTypes } from './voiceCallActions';

const defaultOptOutInteraction: MessageInteraction = {
    type: VoiceContentAction.DO_NOT_DISTURB,
    message: [
        {
            text: "You've opted-out of receiving further calls, thank you.",
            type: 'text',
        },
    ],
    keypadOption: '9',
};

export const intitialVoiceCallState: VoiceCallRoot = {
    type: VoiceContentAction.PLAY_MESSAGE,
    message: [{ type: 'text', text: '' }],
    interactions: [defaultOptOutInteraction],
};

export const voiceContentInitialState: VoiceContentStateTypes = {
    name: '',
    voiceJson: {
        voiceCall: intitialVoiceCallState,
    },
    applicationsAccess: [ApplicationAccessType.OUTREACH],
    communicationType: CommunicationType.COMMERCIAL,
    status: ContentStatus.DRAFT,
};

export const voiceContentReducer = (state: VoiceContentStateTypes, action: any): VoiceContentStateTypes => {
    switch (action.type) {
        case actionTypes.SET_NAME: {
            return {
                ...state,
                name: action.name,
            };
        }
        case actionTypes.SET_VOICE_CALL_ROOT_MESSAGE: {
            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    voiceCall: {
                        ...state.voiceJson.voiceCall,
                        message: action.message,
                    },
                },
            };
        }
        case actionTypes.ADD_INTERACTION: {
            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    voiceCall: {
                        ...state.voiceJson.voiceCall,
                        interactions: [...state.voiceJson.voiceCall.interactions, { keypadOption: '' }],
                    },
                },
            };
        }
        case actionTypes.UPDATE_INTERACTION: {
            const { interaction, index } = action.parameters;
            const updatedInteractions = [...state.voiceJson.voiceCall.interactions];
            updatedInteractions[index] = interaction;

            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    voiceCall: {
                        ...state.voiceJson.voiceCall,
                        interactions: updatedInteractions,
                    },
                },
            };
        }
        case actionTypes.REMOVE_INTERACTION: {
            const updatedInteractions = [...state.voiceJson.voiceCall.interactions];
            updatedInteractions.splice(action.index, 1);

            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    voiceCall: {
                        ...state.voiceJson.voiceCall,
                        interactions: updatedInteractions,
                    },
                },
            };
        }
        case actionTypes.SET_VOICE_CONTENT_STATE: {
            return {
                applicationsAccess: action.voiceContentState.applicationsAccess,
                communicationType: action.voiceContentState.communicationType,
                name: action.voiceContentState.name,
                voiceJson: action.voiceContentState.voiceJson,
            };
        }
        case actionTypes.ADD_VOICEMAIL_MESSAGE: {
            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    voicemail: action.voicemail,
                },
            };
        }
        case actionTypes.REMOVE_VOICEMAIL_MESSAGE: {
            const { voicemail, ...rest } = state.voiceJson;

            return {
                ...state,
                voiceJson: {
                    ...rest,
                },
            };
        }
        case actionTypes.SET_WAIT_TIME: {
            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    fallback: {
                        ...state.voiceJson.fallback,
                        waitTime: action.waitTime,
                    },
                },
            };
        }
        case actionTypes.SET_REPEAT: {
            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    fallback: {
                        ...state.voiceJson.fallback,
                        repeat: action.repeat,
                    },
                },
            };
        }
        case actionTypes.SET_TIMEOUT_MESSAGE: {
            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    fallback: {
                        ...state.voiceJson.fallback,
                        timeoutMessage: action.timeoutMessage,
                    },
                },
            };
        }
        case actionTypes.SET_INCORRECT_RESPONSE_MESSAGE: {
            return {
                ...state,
                voiceJson: {
                    ...state.voiceJson,
                    fallback: {
                        ...state.voiceJson.fallback,
                        incorrectResponseMessage: action.incorrectResponseMessage,
                    },
                },
            };
        }
        case actionTypes.SET_COMMUNICATION_TYPE: {
            return {
                ...state,
                communicationType: action.communicationType,
            };
        }
        case actionTypes.SET_APPLICATIONS_ACCESS: {
            return {
                ...state,
                applicationsAccess: action.applicationsAccess,
            };
        }

        default:
            return state;
    }
};
